import useSWR from 'swr';
import { FeeSection } from '@/apiClient';
import { usePrivate } from '@/components/private';
import { enqueueSnackbar } from '@/providers';

export interface useGetFeeOptions {
  shouldFetch?: boolean;
}

export function useGetFee(feeSection: FeeSection, options?: useGetFeeOptions) {
  const mergedOptions: useGetFeeOptions = {
    shouldFetch: true,
    ...options,
  };

  const { feeApi, selectedOrganisationId } = usePrivate();

  const results = useSWR(
    feeApi && selectedOrganisationId && mergedOptions.shouldFetch
      ? `/api/Fee/GetFeeByOrganisationId/${selectedOrganisationId}`
      : null,
    () => feeApi?.apiFeeGetFeeByOrganisationIdGet(selectedOrganisationId!),
    {
      onError: (error) => {
        enqueueSnackbar(
          'Failed to fetch fee information. Please try again later.',
          {
            variant: 'error',
          },
        );
        console.error(
          '[BREEDLOGIC] <useGetFee> error fetching fee information.',
          error,
        );
      },
    },
  );

  const isLoadingOrValidating =
    results.isLoading || results.isValidating || !feeApi;

  const fee =
    results.data?.data.find((res) => res.itemType === feeSection) || null;

  return { ...results, fee, isLoadingOrValidating };
}
